import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_SUB_CATEGORY_TICKET, GET_SUB_CATEGORY_TICKET_SUCCESS, GET_SUB_CATEGORY_TICKET_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSubCategoryTicket({ payload }) {
  const { categoryId } = payload.data;
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/sub-categories-list?category=${categoryId}`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SUB_CATEGORY_TICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SUB_CATEGORY_TICKET_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SUB_CATEGORY_TICKET_ERROR, payload: error });
  }
}

export function* watchGetSubCategoryTicket() {
  yield takeEvery(GET_SUB_CATEGORY_TICKET, getSubCategoryTicket);
}

function* getSubCategoryTicketSaga() {
  yield all([fork(watchGetSubCategoryTicket)]);
}

export default getSubCategoryTicketSaga;
